/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vaGNhLWFkbWluL2VtcGxveWVlcy9lbXBsb3llZS1leGNoYW5nZS1iZW5lZml0cy9lbXBsb3llZS1leGNoYW5nZS1iZW5lZml0cy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2FkbWluL2hjYS1hZG1pbi9lbXBsb3llZXMvZW1wbG95ZWUtZXhjaGFuZ2UtYmVuZWZpdHMvZW1wbG95ZWUtZXhjaGFuZ2UtYmVuZWZpdHMuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/admin/hca-admin/employees/employee-exchange-benefits/employee-exchange-benefits.component.scss.shim.ngstyle.ts